/*
 * common.js
 * 전체 프로젝트 공통 유틸리티 함수 + AJAX 헬퍼
 *
 * 사용법:
 *   - 모든 blade에서 apiGet(), apiPost(), apiDelete() 사용 가능
 */

// ============================================================
// AJAX 헬퍼 (70개 blade 파일에서 공통 사용)
// ============================================================

/**
 * 공통 AJAX 요청 함수
 * 내부 브라우저 AJAX는 세션/Sanctum + CSRF 헤더를 기본으로 사용한다.
 *
 * @param {Object} options - $.ajax 옵션 (url, type, data 등)
 * @returns {jqXHR}
 */
function apiRequest(options) {
    var defaults = {
        cache: false,
    };
    var requestOptions = $.extend({}, options || {});
    var csrfToken = skmGetCsrfToken();
    var headers = $.extend({
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
    }, requestOptions.headers || {});

    if (csrfToken && !headers['X-CSRF-TOKEN']) {
        headers['X-CSRF-TOKEN'] = csrfToken;
    }

    requestOptions.headers = headers;
    // 이전 호출부가 넘기던 옵션은 무시하되 $.ajax 로 흘러가지 않게 제거한다.
    delete requestOptions.skipApiToken;

    return $.ajax($.extend(defaults, requestOptions));
}

function skmGetCsrfToken() {
    if (typeof document === 'undefined') {
        return '';
    }

    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
}

function skmSessionApiRequest(options) {
    return apiRequest(options);
}

function skmSessionApiGet(url, data, onSuccess, onError) {
    return skmSessionApiRequest({
        type: 'GET',
        url: url,
        data: data || {},
        success: onSuccess,
        error: onError || function (response) {
            Swal.fire('실패!', '서버에 오류가 발생.', 'error');
        }
    });
}

function skmSessionApiPost(url, data, onSuccess, onError) {
    return skmSessionApiRequest({
        type: 'POST',
        url: url,
        data: data || {},
        success: onSuccess,
        error: onError || function (response) {
            Swal.fire('실패!', '서버에 오류가 발생.', 'error');
        }
    });
}

function skmSessionApiDelete(url, data, onSuccess, onError) {
    return skmSessionApiRequest({
        type: 'DELETE',
        url: url,
        data: data || {},
        success: onSuccess,
        error: onError || function (response) {
            Swal.fire('실패!', '서버에 오류가 발생.', 'error');
        }
    });
}

/**
 * GET 요청 헬퍼
 * @param {string} url
 * @param {Object} data - 쿼리 파라미터
 * @param {Function} onSuccess - function(response)
 * @param {Function} [onError] - function(response), 기본값: Swal 에러 알림
 */
function apiGet(url, data, onSuccess, onError) {
    return apiRequest({
        type: 'GET',
        url: url,
        data: data || {},
        success: onSuccess,
        error: onError || function (response) {
            Swal.fire('실패!', '서버에 오류가 발생.', 'error');
        }
    });
}

/**
 * POST 요청 헬퍼
 * @param {string} url
 * @param {Object} data - POST 데이터
 * @param {Function} onSuccess - function(response)
 * @param {Function} [onError] - function(response), 기본값: Swal 에러 알림
 */
function apiPost(url, data, onSuccess, onError) {
    return apiRequest({
        type: 'POST',
        url: url,
        data: data || {},
        success: onSuccess,
        error: onError || function (response) {
            Swal.fire('실패!', '서버에 오류가 발생.', 'error');
        }
    });
}

/**
 * DELETE 요청 헬퍼
 * @param {string} url
 * @param {Object} data - DELETE 데이터
 * @param {Function} onSuccess - function(response)
 * @param {Function} [onError] - function(response), 기본값: Swal 에러 알림
 */
function apiDelete(url, data, onSuccess, onError) {
    return apiRequest({
        type: 'DELETE',
        url: url,
        data: data || {},
        success: onSuccess,
        error: onError || function (response) {
            Swal.fire('실패!', '서버에 오류가 발생.', 'error');
        }
    });
}

// ============================================================
// 유틸리티 함수 (app.blade.php에서 추출)
// ============================================================

function debounce(func, delay) {
    var timer;
    return function () {
        var args = arguments;
        var context = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    }
}

/* 동적페이지 설정할때 파라미터 업데이트 하는 함수 */
function updateUrlParams(params, preserveExisting) {
    if (preserveExisting === undefined) preserveExisting = true;
    var url = new URL(window.location);
    if (!preserveExisting) {
        url.search = '';
    }
    Object.entries(params).forEach(function (entry) {
        url.searchParams.set(entry[0], entry[1]);
    });
    window.history.replaceState(null, '', url);
}

function 학년계산(birthDate) {
    var age = parseInt(new Date().getFullYear() - new Date(birthDate).getFullYear()) + 1;
    var grade = parseInt(age < 14 ? age - 7 : (age - 13) % 3);
    return grade == 0 ? 3 : grade;
}

function 상담_학년계산(grade) {
    if (grade < 7) {
        return '초_' + grade;
    } else if (grade < 10) {
        return '중_' + (grade - 6);
    } else if (grade < 13) {
        return '고_' + (grade - 9);
    }
    return '';
}

function addComma(x) {
    var isNegative = x < 0;
    var numStr = Math.abs(x).toString();
    var withCommas = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return isNegative ? '-' + withCommas : withCommas;
}

function unComma(str) {
    str = String(str);
    return str.replace(/[^\d]+/g, '');
}

function formatDate청구월(year, month) {
    var date = new Date(year, month - 1);
    var yearShort = date.getFullYear() % 100;
    var monthFormatted = date.getMonth() + 1;
    return yearShort + '년 ' + monthFormatted + '월';
}

function formatDueDate(year, month) {
    var previousMonthYear = month === 1 ? year - 1 : year;
    var previousMonth = month === 1 ? 12 : month - 1;
    var lastDate = new Date(previousMonthYear, previousMonth, 0);
    var y = lastDate.getFullYear();
    var m = lastDate.getMonth() < 10 ? '0' + (lastDate.getMonth() + 1) : lastDate.getMonth() + 1;
    var d = lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate();
    return y + '-' + m + '-' + d;
}

function convertFullDateFormat(dateStr) {
    var year = dateStr.substring(0, 4);
    var month = dateStr.substring(4, 6);
    var day = dateStr.substring(6, 8);
    var hour = dateStr.substring(8, 10);
    var minute = dateStr.substring(10, 12);
    var second = dateStr.substring(12, 14);
    return skmDate.format(
        year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second,
        'YYYY년 MM월 DD일 HH:mm:ss',
        { parsePattern: 'YYYY-MM-DD HH:mm:ss' }
    );
}

function convertDateFormat(dateStr) {
    var year = dateStr.substring(0, 2);
    var month = dateStr.substring(2, 4);
    var day = dateStr.substring(4, 6);
    var hour = dateStr.substring(6, 8);
    var minute = dateStr.substring(8, 10);
    var second = dateStr.substring(10, 12);
    return skmDate.format(
        '20' + year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second,
        'YYYY년 MM월 DD일 HH:mm:ss',
        { parsePattern: 'YYYY-MM-DD HH:mm:ss' }
    );
}

function checkEmptyPhoneNumber(phoneNumber) {
    if (!phoneNumber || phoneNumber === '010--' || phoneNumber === '010-0000-0000') {
        return '';
    }
    return phoneNumber;
}

function isFourDigit(val) {
    return /^\d{4}$/.test(val);
}

/**
 * HTML 특수문자 이스케이프.
 *
 * 🔴 문자열이 아닌 값도 받는다. 예전에는 인자에 바로 .replace() 를 불렀는데, 숫자에는 그 메서드가
 *    없어 **TypeError 로 터졌다.** 그 예외가 fetch 체인 안에서 나면 뒤의 .catch() 가 잡아 «API 실패»
 *    로 오인 표시된다 — 실제로 단체문자 개별검색이 성공했는데도 「검색 실패」가 떴다
 *    (원장님 보고 2026-08-23. 원인은 결과를 그릴 때 학생 id(JSON 숫자)를 이 함수에 넘긴 것).
 *
 *    전역 함수라 같은 지뢰가 다른 화면에도 있다. 호출부마다 String() 을 씌우는 대신 여기서 받는다.
 *
 * null·undefined 는 빈 문자열이다(«값이 없다»). 다만 0 과 false 는 **그리는 것이 맞다** —
 * 예전에는 falsy 라는 이유로 함께 지웠는데, 그러면 «0건» 같은 정당한 값이 화면에서 조용히 사라진다.
 */
function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    return String(text).replace(/[&<>"']/g, function (m) {
        return ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
        })[m];
    });
}

function formatHHMM(timeStr) {
    return timeStr ? timeStr.slice(0, 5) : '';
}

function setNativeSelectValue($select, value) {
    if ($select.find('option[value="' + value + '"]').length > 0) {
        $select.val(value);
    } else {
        $select.val('');
        console.warn('옵션 값에  "' + value + '" 가 없습니다. Selector: #' + $select.attr('id'));
    }
    return $select;
}

// 폰트 크기 관련 함수
function updateFontSize(elementsToResize, fontSizeDisplay, fontSize) {
    elementsToResize.forEach(function (selector) {
        var elements = document.querySelectorAll(selector);
        elements.forEach(function (element) {
            applyFontSizeRecursively(element, fontSize);
        });
    });
    updateFontSizeDisplay(fontSizeDisplay, fontSize);
}

function applyFontSizeRecursively(element, fontSize) {
    element.style.setProperty('font-size', fontSize + 'px', 'important');
    Array.from(element.children).forEach(function (child) {
        applyFontSizeRecursively(child, fontSize);
    });
}

function saveFontSize(fontSize) {
    localStorage.setItem('fontSize', fontSize);
}

function updateFontSizeDisplay(fontSizeDisplay, fontSize) {
    if (fontSizeDisplay) {
        fontSizeDisplay.textContent = 'Font Size: ' + fontSize + 'px';
    }
}

function getSavedFontSize() {
    return parseInt(localStorage.getItem('fontSize') || '12', 10);
}

var stringformat = function (text) {
    if (arguments.length <= 1) return text;
    for (var i = 0; i <= arguments.length - 2; i++) {
        text = text.replace(new RegExp("\\{" + i + "\\}", "gi"), arguments[i + 1]);
    }
    return text;
};

/**
 * ── 글자수 제한 입력 공통 컴포넌트 (원장님 DRY 철학 2026-06-14) ──
 * book/class 의 제목·별칭 23자 제한 등을 한 곳에서 공유한다. data-skm-maxlen="23" 입력을 자동 감지:
 *   - 실시간: 초과 시 input 빨간 테두리(.is-over-limit) + 카운터 'N/max'(.is-over)
 *   - 제출: 초과 입력이 있으면 제출을 막고 SweetAlert(skm.error) + 해당 입력 focus
 * 카운터 요소는 partial 이 만든 id="{input.id}-count" 를 사용(없으면 카운터 갱신만 skip).
 * _shared/_char_limited_input.blade.php + skm-components.css(.skm-maxlen-*) 와 한 세트.
 */
function skmCharLimitUpdate(input) {
    var max = parseInt(input.getAttribute('data-skm-maxlen'), 10);
    if (isNaN(max) || max <= 0) { return false; }
    var len = (input.value || '').length;
    var over = len > max;
    input.classList.toggle('is-over-limit', over);
    input.setAttribute('aria-invalid', over ? 'true' : 'false');
    var counter = input.id ? document.getElementById(input.id + '-count') : null;
    if (counter) {
        counter.textContent = len + '/' + max;
        counter.classList.toggle('is-over', over);
    }
    return over;
}

function skmCharLimitLabel(input) {
    if (input.getAttribute('data-skm-maxlen-label')) { return input.getAttribute('data-skm-maxlen-label'); }
    if (input.labels && input.labels[0]) { return (input.labels[0].textContent || '').trim(); }
    return '입력값';
}

function skmInitCharLimit(root) {
    var scope = root || (typeof document !== 'undefined' ? document : null);
    // 비-DOM / 부분 DOM 평가 환경(테스트 vm, SSR 등) 안전 가드.
    if (!scope || typeof scope.querySelectorAll !== 'function') { return; }
    var inputs = scope.querySelectorAll('input[data-skm-maxlen]');
    var forms = [];
    Array.prototype.forEach.call(inputs, function (input) {
        skmCharLimitUpdate(input);
        if (!input.dataset.skmMaxlenBound) {
            input.addEventListener('input', function () { skmCharLimitUpdate(input); });
            input.dataset.skmMaxlenBound = '1';
        }
        if (input.form && forms.indexOf(input.form) === -1) { forms.push(input.form); }
    });
    forms.forEach(function (form) {
        if (form.dataset.skmMaxlenFormBound) { return; }
        form.dataset.skmMaxlenFormBound = '1';
        form.addEventListener('submit', function (e) {
            var over = Array.prototype.filter.call(
                form.querySelectorAll('input[data-skm-maxlen]'),
                function (input) { return skmCharLimitUpdate(input); }
            );
            if (over.length) {
                e.preventDefault();
                var first = over[0];
                var max = first.getAttribute('data-skm-maxlen');
                var text = skmCharLimitLabel(first) + '은(는) ' + max + '글자를 초과할 수 없습니다. (현재 '
                    + (first.value || '').length + '글자)';
                if (window.skm && window.skm.error) {
                    window.skm.error('글자수 초과', { text: text });
                } else {
                    alert(text);
                }
                first.focus();
            }
        });
    });
}

Object.assign(window, {
    apiRequest: apiRequest,
    skmGetCsrfToken: skmGetCsrfToken,
    skmSessionApiRequest: skmSessionApiRequest,
    skmSessionApiGet: skmSessionApiGet,
    skmSessionApiPost: skmSessionApiPost,
    skmSessionApiDelete: skmSessionApiDelete,
    apiGet: apiGet,
    apiPost: apiPost,
    apiDelete: apiDelete,
    debounce: debounce,
    updateUrlParams: updateUrlParams,
    학년계산: 학년계산,
    상담_학년계산: 상담_학년계산,
    addComma: addComma,
    unComma: unComma,
    formatDate청구월: formatDate청구월,
    formatDueDate: formatDueDate,
    convertFullDateFormat: convertFullDateFormat,
    convertDateFormat: convertDateFormat,
    checkEmptyPhoneNumber: checkEmptyPhoneNumber,
    isFourDigit: isFourDigit,
    escapeHtml: escapeHtml,
    formatHHMM: formatHHMM,
    setNativeSelectValue: setNativeSelectValue,
    updateFontSize: updateFontSize,
    applyFontSizeRecursively: applyFontSizeRecursively,
    saveFontSize: saveFontSize,
    updateFontSizeDisplay: updateFontSizeDisplay,
    getSavedFontSize: getSavedFontSize,
    stringformat: stringformat,
    skmInitCharLimit: skmInitCharLimit,
    skmCharLimitUpdate: skmCharLimitUpdate,
});

// 글자수 제한 입력 자동 초기화 (DOM 로딩 중 / 이미 로드 양쪽 안전, 비-DOM 평가 환경 가드)
if (typeof document !== 'undefined' && document.addEventListener) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { skmInitCharLimit(); });
    } else {
        skmInitCharLimit();
    }
}
